import { generate_uuid } from "lib/helpers";
import {TextField, Loading,CheckBox, Select,SelectItem,TextArea} from 'components/form';
import {Formik, Field, Form} from 'formik';
import {required, validationWrapper, number} from 'lib/formValidations';
import {transformTranslateFromValues} from 'lib/helpers';
import Modal from 'components/Modal';
export function AddPrices(props) {
    return (
      <Modal show={props.show} zIndex={1024} handleClose={props.close} title="افزودن قیمت">
        <Formik
          key="fromik_p_price"
          initialValues={{ uuid: generate_uuid() }}
          onSubmit={(values, { setSubmitting }) => {
            props.submit(values);
            props.close();
            setSubmitting(false);
          }}
        >
          {({ isSubmitting, dirty, handleSubmit }) => (
            <Form>
              <div className="modal-body gap-y-3">
                <div className="intro-x grid md:grid-cols-3 md:gap-3">
                  <div className="">
                    <Field
                      placeholder="واحد پولی"
                      label="واحد پولی :"
                      name="currency"
                      component={Select}
                      options={[
                        { value: "IRR", label: "تومان" },
                        { value: "USD", label: "دلار" },
                      ]}
                      validate={(value) => validationWrapper(value, required)}
                    />
                  </div>
                  <div className="">
                    <Field
                      placeholder="مقدار"
                      label="مقدار :"
                      name="amount"
                      component={TextField}
                      validate={(value) => validationWrapper(value, required)}
                    />
                  </div>
                  <div className="">
                    <Field label="وضعیت" name="status" component={CheckBox} />
                  </div>
                </div>
              </div>
              <div className="modal-footer text-right">
                <button
                  className="btn btn-primary w-20"
                  type="button"
                  onClick={handleSubmit}
                  disabled={!!(isSubmitting || !dirty)}
                >
                  {isSubmitting ? <Loading /> : "ذخیره"}
                </button>
                <button
                  type="button"
                  disabled={isSubmitting}
                  onClick={props.close}
                  className="btn btn-outline-secondary w-20 mr-1"
                >
                  انصراف
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal>
    );
  }
